import ServiceCollection from "src/services/ServiceCollection";
import {Box} from "@amzn/awsui-components-react";
import React from "react";

export default function StandaloneJEWorksheetView(props: { services: ServiceCollection }) {
    return (
        // TODO: Add standalone JE worksheet components
        <Box padding={{top: "xxl"}}>
        </Box>
    );
}
